import React from 'react'
import { Box, Typography, Button, IconButton } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import Dialog from 'components/dialog'
import CelebrationOutlinedIcon from 'components/material-symbol/icons/Celebration'
import OpenInNewOutlinedIcon from 'components/material-symbol/icons/OpenInNew'
import { STRIPE_CUSTOMER_PORTAL_URL } from 'env'

const useStyles = makeStyles(theme => ({
  successIcon: {
    background: 'rgba(0, 35, 75, 0.08)',
    padding: '16px',
    marginBottom: theme.spacing(1.5),
    '&:hover': {
      background: 'rgba(0, 35, 75, 0.08)',
    },
    '& svg, & .MuiSvgIcon-root': {
      color: theme.palette.blue.dark,
    },
  },
  textWrapper: {
    maxWidth: '656px',
    textAlign: 'center',
    marginBottom: theme.spacing(4),
  },
}))

const UpgradeSuccessModal = ({ isOpen, onClose, onManagePlan }) => {
  const classes = useStyles()

  const handleManagePlan = () => {
    window.open(STRIPE_CUSTOMER_PORTAL_URL, '_blank')
    if (onManagePlan) {
      onManagePlan()
    }
  }

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      showCloseButton
    >
      {({ closeDialog }) => (
        <Box p={4} textAlign="center">
          {/* Success Icon */}
          <Box display="flex" justifyContent="center" mb={3}>
            <IconButton className={classes.successIcon}>
              <CelebrationOutlinedIcon fontSize="large" />
            </IconButton>
          </Box>

          {/* Success Title */}
          <Typography
            variant="h4"
            style={{ marginBottom: '16px', fontWeight: '500' }}
          >
            Success!
          </Typography>

          {/* Success Message */}
          <Typography variant="body1" className={classes.textWrapper}>
            You have successfully subscribed to PGA Coach+! You will receive an
            email confirmation shortly. To manage your subscription, visit
            Stripe.
          </Typography>

          {/* Action Buttons */}
          <Box display="flex" flexDirection="column" alignItems="center">
            <Button
              variant="contained"
              color="primary"
              startIcon={<OpenInNewOutlinedIcon />}
              onClick={handleManagePlan}
            >
              Manage Plan
            </Button>
            <Button
              color="primary"
              onClick={onClose}
              style={{ marginTop: '20px' }}
            >
              Dismiss
            </Button>
          </Box>
        </Box>
      )}
    </Dialog>
  )
}

export default UpgradeSuccessModal
